import { Component, Prop, Vue } from "vue-property-decorator";
import Template from "./PayoutReason.template.vue";

@Component({
  mixins: [Template]
})
export class PayoutReasonComponent extends Vue {
  @Prop({ required: true }) public payout!: { description: string };
}
